import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { PlayCircle, Clock, ArrowRight, Headphones } from 'lucide-react';
const fadeIn = {
  initial: {
    opacity: 0,
    y: 20
  },
  whileInView: {
    opacity: 1,
    y: 0
  },
  viewport: {
    once: true,
    margin: '-100px'
  },
  transition: {
    duration: 0.6
  }
};
export function Blog() {
  const articles = [{
    id: 1,
    title: 'The Impact of Tech Education in Rural Communities',
    cat: 'Education',
    read: '5 min read',
    img: 'https://images.unsplash.com/photo-1503676260728-1c00da094a0b?q=80&w=2922&auto=format&fit=crop'
  }, {
    id: 2,
    title: 'Preserving Cultural Heritage in the Digital Age',
    cat: 'Culture',
    read: '4 min read',
    img: 'https://images.unsplash.com/photo-1523805009345-7448845a9e53?q=80&w=2944&auto=format&fit=crop'
  }, {
    id: 3,
    title: 'Success Story: From Wonder Boy Trainee to Head Chef',
    cat: 'Success Stories',
    read: '6 min read',
    img: 'https://images.unsplash.com/photo-1555939594-58d7cb561ad1?q=80&w=2940&auto=format&fit=crop'
  }];
  return <div className="pt-0 bg-warmwhite" data-id="element-248" data-mp="2bv5jwqcgge0v">
      {/* Hero Section */}
      <section className="relative pt-32 pb-16 bg-navy overflow-hidden" data-id="element-249" data-mp="2bvyu61amhlnr">
        <div className="absolute inset-0 z-0" data-id="element-250" data-mp="2fvph1tx13hn0">
          <img src="https://images.unsplash.com/photo-1455390582262-044cdead2708?q=80&w=2940&auto=format&fit=crop" alt="Blog and Resources" className="w-full h-full object-cover opacity-20" data-id="element-251" data-mp="2fyle7g11y2ae" />
          <div className="absolute inset-0 bg-gradient-to-t from-navy via-navy/80 to-transparent" data-id="element-252" data-mp="1s6wrcf70260u" />
        </div>
        <div className="container mx-auto px-6 md:px-12 relative z-10 text-center max-w-4xl" data-id="element-253" data-mp="1x7c7feio1rmi">
          <h1 className="text-5xl md:text-6xl font-serif font-bold text-white mb-6" data-id="element-254" data-mp="33lbgmihbbyvj">
            Stories & Resources
          </h1>
          <p className="text-xl text-white/80 leading-relaxed mb-8" data-id="element-255" data-mp="38jldqymll9js">
            Learn, get inspired, and stay updated on news, podcasts, and
            insights from Poch Global.
          </p>
        </div>
      </section>

      {/* Featured Article */}
      <section className="py-12 lg:py-16" data-id="element-256" data-mp="1ihmg6tdviaey">
        <div className="container mx-auto px-4 sm:px-6 md:px-12" data-id="element-257" data-mp="1igl02ai02xqd">
          <motion.div variants={fadeIn} initial="initial" whileInView="whileInView" className="bg-white rounded-3xl overflow-hidden shadow-premium flex flex-col lg:flex-row" data-id="element-258" data-mp="1djb5yhjo1xw7">
            <div className="w-full lg:w-3/5 h-[300px] sm:h-[400px] lg:h-auto relative" data-id="element-259" data-mp="krj38mwfyga1">
              <img src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?q=80&w=2942&auto=format&fit=crop" alt="Featured" className="w-full h-full object-cover" data-id="element-260" data-mp="zjtajjbv7mdv" />
            </div>
            <div className="w-full lg:w-2/5 p-6 sm:p-10 lg:p-16 flex flex-col justify-center" data-id="element-261" data-mp="23mebcvgwap2">
              <span className="text-gold font-bold tracking-wider uppercase text-xs lg:text-sm mb-3 lg:mb-4" data-id="element-262" data-mp="2dpy25g25pbrn">
                Featured Story
              </span>
              <h2 className="text-2xl lg:text-3xl font-serif font-bold text-navy mb-3 lg:mb-4" data-id="element-263" data-mp="2ij9a5kipfyl5">
                Building Sustainable Futures: Our 2026 Impact Report
              </h2>
              <p className="text-sm lg:text-base text-mediumgray mb-4 lg:mb-6 line-clamp-3" data-id="element-264" data-mp="28rmunbzc3dcl">
                Discover how our community-led initiatives have transformed over
                100 communities this year, focusing on education, health, and
                economic empowerment.
              </p>
              <div className="flex items-center gap-3 lg:gap-4 text-xs lg:text-sm text-mediumgray mb-6 lg:mb-8" data-id="element-265" data-mp="2nidm2ix0kaf6">
                <span data-id="element-266" data-mp="2sh71igvv2bhz">By Funke Akinwunmiju</span>
                <span data-id="element-267" data-mp="1c02p7l9ecjsz">•</span>
                <span className="flex items-center gap-1" data-id="element-268" data-mp="1bzt2q7nk8us1">
                  <Clock className="w-3 h-3 lg:w-4 lg:h-4" data-id="element-269" data-mp="1h0gyf6mqhzsl" /> 8 min read
                </span>
              </div>
              <button className="self-start px-6 py-3 bg-navy hover:bg-navy-light text-white rounded-full font-semibold transition-all text-sm lg:text-base" data-id="element-270" data-mp="1wam3sqkiwr3x">
                Read Full Article
              </button>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Recent Articles */}
      <section className="py-12 lg:py-16 bg-white" data-id="element-271" data-mp="1ik0ikv7lk52v">
        <div className="container mx-auto px-4 sm:px-6 md:px-12" data-id="element-272" data-mp="2f9844387ue6s">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-end mb-8 lg:mb-10 gap-4" data-id="element-273" data-mp="2f6lu7wxurmle">
            <h2 className="text-3xl font-serif font-bold text-navy" data-id="element-274" data-mp="26805tl5p9dcp">
              Recent Articles
            </h2>
            <div className="flex overflow-x-auto pb-2 md:pb-0 w-full md:w-auto gap-2" data-id="element-275" data-mp="219giphfddvir">
              {['All', 'News', 'Success Stories', 'Culture', 'Education', 'Entrepreneurship'].map(cat => <button key={cat} className="px-4 py-2 rounded-full text-xs lg:text-sm font-medium text-mediumgray hover:bg-warmwhite transition-colors whitespace-nowrap border border-softgray md:border-none" data-id="element-276" data-mp="pt8qa8tnk0kt">
                  {cat}
                </button>)}
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8" data-id="element-277" data-mp="3afp8nlkfs5k5">
            {articles.map(article => <motion.div key={article.id} variants={fadeIn} initial="initial" whileInView="whileInView" className="group cursor-pointer" data-id="element-278" data-mp="3k84oodc6ak2e">
                <div className="rounded-2xl overflow-hidden mb-4 h-56" data-id="element-279" data-mp="3u73za1gi0ps1">
                  <img src={article.img} alt={article.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-280" data-mp="229ve2uxvclq" />
                </div>
                <span className="text-gold text-xs font-bold uppercase tracking-wider mb-2 block" data-id="element-281" data-mp="23vfxzhpjkudn">
                  {article.cat}
                </span>
                <h3 className="text-xl font-bold text-navy mb-2 group-hover:text-gold transition-colors" data-id="element-282" data-mp="3267omkni6a0t">
                  {article.title}
                </h3>
                <div className="flex items-center gap-2 text-sm text-mediumgray" data-id="element-283" data-mp="3c3dfpsw4a111">
                  <Clock className="w-4 h-4" data-id="element-284" data-mp="3c5gb6sg1gmd5" /> {article.read}
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* Podcast Section */}
      <section className="py-12 lg:py-16 bg-navy text-white" data-id="element-285" data-mp="3l1xqm7vfr6ep">
        <div className="container mx-auto px-4 sm:px-6 md:px-12" data-id="element-286" data-mp="3m8tv9soz9qr">
          <div className="flex flex-col lg:flex-row gap-12 lg:gap-16 items-center" data-id="element-287" data-mp="3uu3dx4aqsznk">
            <div className="w-full lg:w-1/2" data-id="element-288" data-mp="co8cu7n9onwc">
              <div className="w-12 h-12 lg:w-16 lg:h-16 bg-gold/20 text-gold-light rounded-2xl flex items-center justify-center mb-4 lg:mb-6" data-id="element-289" data-mp="cp081hcycjm3">
                <Headphones className="w-6 h-6 lg:w-8 lg:h-8" data-id="element-290" data-mp="7nay651gubzl" />
              </div>
              <h2 className="text-3xl lg:text-4xl font-serif font-bold text-white mb-4 lg:mb-6" data-id="element-291" data-mp="r8ukrl0pwzvw">
                Poch Global Podcast
              </h2>
              <p className="text-white/70 text-base lg:text-lg mb-6 lg:mb-8" data-id="element-292" data-mp="ib0p8cas2a9s">
                Listen to inspiring conversations on African culture,
                entrepreneurship, education, and leadership with thought leaders
                from around the globe.
              </p>
              <button className="w-full sm:w-auto px-6 lg:px-8 py-3 lg:py-4 bg-gold hover:bg-gold-light text-white rounded-full font-bold transition-all shadow-lg flex items-center justify-center gap-2 text-sm lg:text-base" data-id="element-293" data-mp="dbo6a2n11nch">
                <PlayCircle className="w-4 h-4 lg:w-5 lg:h-5" data-id="element-294" data-mp="3me9wal5hiik" /> Listen to Latest Episode
              </button>
            </div>
            <div className="w-full lg:w-1/2" data-id="element-295" data-mp="3lrratziuevwl">
              <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-3xl p-5 lg:p-6" data-id="element-296" data-mp="3qqkfr3k2del5">
                <h3 className="font-bold text-white text-base lg:text-lg mb-4 border-b border-white/10 pb-4" data-id="element-297" data-mp="a2y22fmfb0ml">
                  Recent Episodes
                </h3>
                <div className="space-y-3 lg:space-y-4" data-id="element-298" data-mp="4i7g2o6t98c">
                  {[1, 2, 3].map(i => <div key={i} className="flex items-center gap-3 lg:gap-4 p-2 lg:p-3 hover:bg-white/5 rounded-xl transition-colors cursor-pointer group" data-id="element-299" data-mp="3s8az3tgzvtvc">
                      <div className="w-10 h-10 lg:w-12 lg:h-12 bg-white/10 rounded-lg flex items-center justify-center text-white group-hover:bg-gold transition-colors shrink-0" data-id="element-300" data-mp="3ihzndkr2kgdw">
                        <PlayCircle className="w-5 h-5 lg:w-6 lg:h-6" data-id="element-301" data-mp="38klgabr1d3y9" />
                      </div>
                      <div data-id="element-302" data-mp="34igozjo28jes">
                        <h4 className="font-semibold text-white text-sm lg:text-base line-clamp-1" data-id="element-303" data-mp="34hos85iq8fmx">
                          Ep {4 - i}: Empowering the Next Generation of Leaders
                        </h4>
                        <p className="text-[10px] lg:text-xs text-white/50" data-id="element-304" data-mp="1f0t8gce2i3w9">
                          45 mins • Oct 12, 2026
                        </p>
                      </div>
                    </div>)}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Newsletter Signup */}
      <section className="py-12 lg:py-16 bg-warmwhite relative overflow-hidden" data-id="element-305" data-mp="wbd6rlqnc5e9">
        <div className="container mx-auto px-4 sm:px-6 max-w-3xl relative z-10" data-id="element-306" data-mp="w9a5g5k1mpu8">
          <div className="text-center mb-8 lg:mb-12" data-id="element-307" data-mp="10cye6rkevrh2">
            <h2 className="text-3xl lg:text-4xl text-navy font-serif font-bold mb-3 lg:mb-4" data-id="element-308" data-mp="15bjfkubegh73">Get Weekly Updates</h2>
            <p className="text-mediumgray text-base lg:text-lg" data-id="element-309" data-mp="1a3jjexulbu8y">
              Subscribe to receive our latest articles, podcast episodes, and resources.
            </p>
          </div>
          
          <form className="bg-white border border-softgray shadow-premium p-6 sm:p-8 lg:p-10 rounded-3xl" data-id="element-310" data-mp="hl5nx4wq8kd1">
            <div className="mb-6" data-id="element-311" data-mp="12816yllx4d4y">
              <label className="block text-sm font-bold text-navy mb-2" data-id="element-312" data-mp="12b5gzzm2e33j">Email Address</label>
              <input type="email" placeholder="hello@example.com" className="w-full px-6 py-4 rounded-xl bg-warmwhite border border-softgray text-charcoal placeholder:text-mediumgray focus:outline-none focus:border-navy focus:ring-1 focus:ring-navy transition-colors" required data-id="element-313" data-mp="16cha4f45d6gh" />
            </div>
            
            <div className="mb-8" data-id="element-314" data-mp="nk6aqv8pbqn4">
              <label className="block text-sm font-bold text-navy mb-4" data-id="element-315" data-mp="sj9iing2gays">Content Interests (select all that apply):</label>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-316" data-mp="x9zlxv4xm3qu">
                {['News & Updates', 'Success Stories', 'Educational Articles', 'Cultural Insights', 'Entrepreneurship Tips', 'Podcast Episodes'].map(interest => <label key={interest} className="flex items-center gap-3 cursor-pointer group" data-id="element-317" data-mp="4rklwuw7p0c1">
                    <div className="w-5 h-5 rounded border border-softgray flex items-center justify-center group-hover:border-navy transition-colors bg-warmwhite" data-id="element-318" data-mp="3teim9accyi07">
                      <input type="checkbox" className="opacity-0 absolute" data-id="element-319" data-mp="3jg2ud55ib4pn" />
                      <div className="w-3 h-3 rounded-sm bg-navy opacity-0 group-hover:opacity-50 transition-opacity" data-id="element-320" data-mp="3ei9m86kn80mq" />
                    </div>
                    <span className="text-mediumgray group-hover:text-navy transition-colors" data-id="element-321" data-mp="3ahz6i271tvuo">{interest}</span>
                  </label>)}
              </div>
            </div>

            <div className="mb-8" data-id="element-322" data-mp="30ree4whyxnk7">
              <label className="block text-sm font-bold text-navy mb-2" data-id="element-323" data-mp="30o9zf56vn9fa">Frequency</label>
              <select className="w-full px-6 py-4 rounded-xl bg-warmwhite border border-softgray text-charcoal focus:outline-none focus:border-navy focus:ring-1 focus:ring-navy transition-colors appearance-none" data-id="element-324" data-mp="2vpf9ljahsklo">
                <option value="weekly" data-id="element-325" data-mp="2mt7p85uzyxwo">Weekly Digest</option>
                <option value="monthly" data-id="element-326" data-mp="2c46ndettorlv">Monthly Newsletter</option>
                <option value="immediate" data-id="element-327" data-mp="2h5cjznqlsz0o">As soon as published</option>
              </select>
            </div>

            <button type="submit" className="w-full py-4 bg-gold hover:bg-gold-light text-white font-bold rounded-xl transition-all shadow-lg" data-id="element-328" data-mp="2363dxgw43laf">
              Subscribe
            </button>
          </form>
        </div>
      </section>
    </div>;
}